import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-white">
      <p className="text-sm font-semibold text-primary mb-2">404</p>
      <h1 className="text-xl font-semibold text-gray-900 mb-2">Page not found</h1>
      <p className="text-gray-500 max-w-sm">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="mt-6 text-primary font-medium hover:underline">
        Back to dashboard
      </Link>
    </div>
  );
}
